import { forwardRef, HTMLProps } from 'react'
import clsx from 'clsx'

type InputProps = HTMLProps<HTMLInputElement>

const SearchInput = forwardRef<HTMLInputElement, InputProps>(
  ({ className, placeholder = 'Filter', ...rest }, ref) => (
    <input
      className={clsx(
        'bg-gray-100 focus:bg-white focus:shadow flex-1 rounded my-2 ml-2 px-4 py-2 outline-none text-sm text-gray-800',
        className
      )}
      type="text"
      placeholder={placeholder}
      ref={ref}
      {...rest}
    />
  )
)

export default SearchInput
